// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__kTE4m","signIn":"Login_signIn__39ujG"};